import HotSpotMarker from "@/domain/marker/HotSpotMarker";
import ClientBase from "../ClientBase";
import AnomalyMarker from "@/domain/marker/AnomalyMarker";

class HotSpotClient extends ClientBase {
    async getHotSpotContainedAnomaliesById(scanId, hotSpotId){
        const data = await this.get(`api/v1/hotspots/scans/${scanId}/hotspots/${hotSpotId}/anomalies`);
        return data?.map(marker => new AnomalyMarker(marker)) ?? [];
    }

    async getHotSpotById(scanId, hotSpotId){
        const data = await this.get(`api/v1/hotspots/scans/${scanId}/${hotSpotId}`);
        return data ? new HotSpotMarker(data) : null;
    }

    async getHotSpotsByAssetId(assetId){
        const data = await this.getAllPaged(`api/v1/hotspots/assets/${assetId}`);
        return data?.map(hotspot => new HotSpotMarker(hotspot)) ?? [];
    }

    async getHotSpotsByScanId(scanId){
        const data = await this.getAllPaged(`api/v1/hotspots/scans/${scanId}`);
        return data?.map(hotspot => new HotSpotMarker(hotspot)) ?? [];
    }

    async createHotSpot(hotSpot) {
        const data = await this.post('api/v1/hotspots', hotSpot);
        return data ? new HotSpotMarker(data) : null;
    }

    async updateHotSpot(request) {
        const data = await this.put(`api/v1/hotspots/scans/${request.scanId}/hotspots/${request.id}`, request, { headers: { 'If-Match': request.eTag } });
        return data ? new HotSpotMarker(data) : null;
    }

    async updateHotSpotThumbnail(request) {
        const data = await this.put(`api/v1/hotspots/scans/${request.scanId}/hotspots/${request.id}/thumbnail`, request);
        return data ? new HotSpotMarker(data) : null;
    }

    async deleteHotSpot(hotSpot) {
        return await this.delete(`api/v1/hotspots/scans/${hotSpot.scanId}/hotspots/${hotSpot.id}`);
    }
}

export default new HotSpotClient();
